import React from 'react';
import { AppProvider, useApp } from './context/AppContext';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import ArtistProfile from './pages/ArtistProfile';

function LoadingScreen() {
  return (
    <div style={{ minHeight: '100vh', background: '#f5f4f2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 56, height: 56, borderRadius: 4, background: '#1c1c1c', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.2rem' }}>
          <div style={{ width: 24, height: 24, border: '2px solid #c9a96e', borderRadius: 2 }} />
        </div>
        <h2 style={{ color: '#1c1c1c', fontSize: 18, fontFamily: 'Georgia, serif', margin: '0 0 8px' }}>Mehendi by Marjana</h2>
        <p style={{ color: '#aaa', fontSize: 13 }}>Loading...</p>
      </div>
    </div>
  );
}

function AppRoutes() {
  const { currentUser, loading } = useApp();
  if (loading) return <LoadingScreen />;
  if (!currentUser) return <Login />;
  if (currentUser.role === 'admin') return <AdminDashboard />;
  if (currentUser.role === 'artist') return <ArtistProfile />;
  return <Login />;
}

export default function App() {
  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}
